<template>
    <div class="card m-b-0">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <p class='m-b-5'>Servei de Biblioteques, Publicacions i Arxius. Universitat Politècnica de Catalunya · BarcelonaTech.</p>
                    <strong>{{ 'Correu electrònic:' }} <a href='mailto:info.biblioteques@upc.edu' target='_blank'>info.biblioteques@upc.edu<em class="mdi mdi-launch m-l-5"></em></a></strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContacteApp'
    }
</script>
